import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { H3, P, paletteHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import { OutboundLink } from '../../../../../app-kit/components/OutboundLink/OutboundLink';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

const DialogHeading = styled(H3)`
  ${typographyHelper('subtitle01')}
`;

const BodyText = styled(P)`
  color: ${paletteHelper('textSecondary')};
`;

const FeaturesDisclaimerContentContainer = styled.article`
  ${BodyText}:not(:last-child) {
    margin-bottom: ${spacingHelper('large')};
  }
`;

const StyledOutboundLink = styled(OutboundLink)`
  color: ${paletteHelper('textSecondary')};

  &:hover,
  &:focus {
    color: ${paletteHelper('textPrimary')};
  }
`;

export const FeaturesDisclaimerContent: FunctionComponent = () => {
  return (
    <FeaturesDisclaimerContentContainer>
      <BodyText>
        Information shown is approximated based on best available data. It may be outdated or
        inaccurate. Always do your own research or contact agent for more information.
      </BodyText>

      <BodyText>Mobile Data Source: ACCC © Commonwealth of Australia</BodyText>

      <DialogHeading>Additional Features Data</DialogHeading>
      <BodyText>
        &copy; Geoscape Australia. This data is for personal use only and may not be reproduced,
        copied to another person, or used to develop capability, products or services for
        commercialisation or potential commercialisation. See copyright notice and disclaimer{' '}
        <StyledOutboundLink
          href="https://geoscape.com.au/legal/data-copyright-and-disclaimer/"
          outboundLinkType="property-features-disclaimer"
          variant="inline"
          rel="noopener noreferrer"
        >
          here.
        </StyledOutboundLink>
      </BodyText>
    </FeaturesDisclaimerContentContainer>
  );
};

interface PropertyFeaturesDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

export const PropertyFeaturesDisclaimer: FunctionComponent<PropertyFeaturesDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="Property boundary and features data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      gap="0"
    >
      <FeaturesDisclaimerContent />
    </DialogModal>
  );
};
